/**
 * Requirements §4.1/§4.3: which Income tabs exist, and which of them render
 * in a given product context. Single source of truth.
 *
 * This used to be three separate, independently-maintained copies:
 * income.controller.js's flat `TABS` (the routing allowlist for `?tab=`),
 * income.js's own `TABS_BY_CONTEXT` (which tabs render in which context),
 * and ContextSwitcher.js's OWN independent `TABS_BY_CONTEXT` (used to decide
 * which tab a context-switch link should preserve). That third copy being
 * nobody's declared responsibility is exactly how a real bug — switching
 * context away from the Payouts tab silently falling back to Overview —
 * survived ten scoped task reviews during Milestone B2: ContextSwitcher.js
 * was never in any task's file list. Import from here instead of
 * redeclaring, so the next new tab only needs to change one file.
 */
export const TABS_BY_CONTEXT = {
  push: ["overview", "plans", "growth", "attention", "transactions", "payouts"],
  // PRESS Growth is coupons only — no trials or referrals (sc-46003).
  press: [
    "overview",
    "plans",
    "growth",
    "attention",
    "transactions",
    "payouts",
  ],
  all: ["overview", "plans", "transactions", "payouts"],
};

// The flat routing allowlist for `?tab=` — every tab that exists in any
// context, regardless of which contexts render it.
export const TABS = [
  "overview",
  "plans",
  "growth",
  "transactions",
  "attention",
  "payouts",
];
